
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aCQV9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24a7f66b136da9de$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");

var $iR3GG = parcelRequire("iR3GG");

var $PK2Tm = parcelRequire("PK2Tm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$24a7f66b136da9de$export$2e2bcd8739ae039 = async ({ query: query, route: route, match: match }, { tenantContext: tenantContext })=>{
    const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
    const { name: name = '' } = route || {}; // Route can be null according to RouterContext
    let returnDefaultBoard = 'false';
    if (boardId === null) returnDefaultBoard = 'true';
    const { baseUrl: baseUrl } = tenantContext;
    const endpoint = `${baseUrl}/rest/greenhopper/1.0/xboard/config.json?returnDefaultBoard=${returnDefaultBoard}&rapidViewId=${boardId}&_=${Date.now()}&operation=ConfigJson`;
    try {
        const pendingData = (0, $PK2Tm.getInlineScriptData)('SPA_RAPIDBOARD_CONFIG') || (0, $7f4tk.default)(endpoint);
        const data = await pendingData;
        return {
            data: data,
            boardId: boardId,
            route: name
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.classic-projects.board-config.getData',
            message: 'An error was thrown while prefetching board config',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



//# sourceMappingURL=async-resource-rapidboards-config-api.32d9a076.js.map
